export class FaturaAnteciparFormModel {
    constructor(
        public competenciaFinal?: number,
        public meses?: number,
    ) { }
}